import React, { useEffect, useRef, useState } from "react";
import Navbar from "../components/Navbar";
import { usePackage } from "../hooks/usePackage";
import moment from "moment";
import { Paths } from "../router/Paths";
import { useAsyncError, useNavigate } from "react-router-dom";
import Loader from "../components/common/Loader";
import SpecialOfferForm from "./CreateSpecialOfferPage";
import { PackageProps } from "../types/data";
import { SpecialOfferRequest } from "../declarations/specialOffer";

interface FilteOption {}

const ManageSpecialOffersPage: React.FC = () => {
  const {
    specialOffers,
    getSpecialOffers,
    getPackageData,
    deleteSpecialOffer,
    getPackage,
    updateSpecialOfferStatus,
  } = usePackage();
  const [specialOffer, setSpecialOffer] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const [isOpend, setIsOpended] = useState(true);
  const [selectedPackages, setSelectedPackages] = useState<string[]>([]);
  const [packageData, setPackageData] = useState<any>([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [offerToDelete, setOfferToDelete] = useState<string | null>(null);
  const [handleDropDown, setHandleDropDown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [packageShowDropDown, setPackageShowDropDown] = useState(false);
  const packagedropdownRef: any = useRef(null);
  const navigate = useNavigate();

  const [filters, setFilters] = useState({
    product: "",
    options: "",
    activeOnly: false,
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);

  const getSpecialOfferFunction = async () => {
    setLoading(true);
    const response = await getSpecialOffers();
    setLoading(false);
    setSpecialOffer(response);
  };

  useEffect(() => {
    getSpecialOfferFunction();
  }, []);

  const handleDropdownToggle = (id: string) => {
    setActiveDropdown((prev) => (prev === id ? null : id));
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setActiveDropdown(null);
      }
      if (
        packagedropdownRef.current &&
        !packagedropdownRef.current.contains(event.target as Node)
      ) {
        setPackageShowDropDown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handlePackageCheckboxToggle = (id: string) => {
    setSelectedPackages((prev: string[] = []) => {
      const updatedPackages = prev.includes(id)
        ? prev.filter((pkgId) => pkgId !== id)
        : [...prev, id];

      return updatedPackages;
    });
  };

  // const filteredOffers = selectedPackages.length > 0
  //   ? specialOffer.offers.filter((item: any) =>
  //       item.packages.some((pkg: any) => selectedPackages.includes(pkg._id))
  //     )
  //   : specialOffer.offers;

  useEffect(() => {
    const getPackageResponse = async () => {
      const results = await getPackageData();
      setPackageData(results || []);
    };
    getPackageResponse();
  }, []);

  const handleEdit = (id: string) => {
    navigate(`${Paths.specialOffers}?id=${id}`);
  };

  const handleDeleteRequest = (id: string) => {
    setOfferToDelete(id);
    setIsModalOpen(true);
  };

  const filteredOffers = specialOffer.offers?.filter((offer: any) => {
    const matchesPackageFilter =
      selectedPackages.length === 0 ||
      offer.packages.some((pkg: any) => selectedPackages.includes(pkg._id));
    const matchesActiveFilter =
      !filters.activeOnly || offer.status === "active";
    return matchesPackageFilter && matchesActiveFilter;
  });

  // Add pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredOffers?.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil((filteredOffers?.length || 0) / itemsPerPage);

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  const confirmDelete = async () => {
    if (offerToDelete) {
      setLoading(true);
      const response = await deleteSpecialOffer({ id: offerToDelete });
      setLoading(false);
      setIsModalOpen(false);
      setOfferToDelete(null);

      if (response.status) {
        getSpecialOfferFunction();
      }
    }
  };

  const cancelDelete = () => {
    setIsModalOpen(false);
    setOfferToDelete(null);
  };

  const handleViewOnline = (id: string) => {};

  const handlePause = async (id: string, currentStatus: string) => {
    const newStatus = currentStatus === "active" ? "paused" : "active";
    const statusData = { status: newStatus };
    setLoading(true);
    const response = await updateSpecialOfferStatus(statusData, id);
    setLoading(false);
    if (response.status === 200) {
      getSpecialOfferFunction();
    }
  };

  console.log("packages", selectedPackages);

  return (
    <div>
      <Navbar />

      <div className="max-w-7xl mx-auto">
        <h1 className="font-bold mt-10 mb-6 sm:mt-10 text-3xl sm:text-4xl max-lg:px-4">
          Manage Special Offer
        </h1>

        <div className="bg-gray-100 p-4 sm:p-6 my-4 sm:my-7 max-w-7xl mx-auto">
          {isOpend && (
            <div className="bg-blue-100 text-blue-800 rounded-md p-3 sm:p-4 flex justify-between items-center mb-4 sm:mb-6">
              <span className="text-sm sm:text-base">
                Your special offer has been created, and is now live.
              </span>
              <button
                className="text-blue-800 font-bold text-xl"
                onClick={() => {
                  setIsOpended(false);
                }}
              >
                &times;
              </button>
            </div>
          )}

          {loading ? (
            <Loader loading={loading} />
          ) : (
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 sm:gap-6">
              {/* Filters Sidebar */}
              <aside className="lg:col-span-3 bg-white p-4 shadow-md rounded-md">
                <h3 className="font-semibold mb-4">Filters</h3>

                <label className="block text-md mb-2 font-medium">
                  Product
                </label>

                <div className="relative">
                  <div
                    className="w-full border border-gray-300 rounded px-4 py-2 cursor-pointer bg-white"
                    onClick={() => setPackageShowDropDown(!packageShowDropDown)}
                  >
                    All Products
                  </div>

                  {packageShowDropDown && (
                    <div
                      ref={packagedropdownRef}
                      className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 rounded-md shadow-md z-10 max-h-48 overflow-y-auto w-full"
                    >
                      {packageData.packages?.map((option: any, index: any) => (
                        <div
                          key={index}
                          className="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100"
                        >
                          <input
                            type="checkbox"
                            id={`option-${index}`}
                            value={option._id}
                            className="mr-2 cursor-pointer"
                            checked={selectedPackages.includes(option._id)}
                            onChange={() =>
                              handlePackageCheckboxToggle(option._id)
                            }
                          />
                          <label
                            htmlFor={`option-${index}`}
                            className="cursor-pointer text-sm sm:text-base"
                          >
                            {option.title}
                          </label>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Options Filter */}
                <label className="block text-md mb-2 font-medium mt-4">
                  Options
                </label>
                <input
                  type="text"
                  placeholder="Options"
                  className="w-full border-2 border-gray-300 rounded-md p-2 text-sm sm:text-base"
                  value={filters.options}
                  onChange={(e) =>
                    setFilters((prev) => ({ ...prev, options: e.target.value }))
                  }
                />

                {/* Status Filter */}
                <label className="block text-md mb-2 font-medium mt-4">
                  Status
                </label>
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="activeOnly"
                    className="mr-2"
                    checked={filters.activeOnly}
                    onChange={(e) =>
                      setFilters((prev) => ({
                        ...prev,
                        activeOnly: e.target.checked,
                      }))
                    }
                  />
                  <label htmlFor="activeOnly" className="text-sm sm:text-base">
                    Active only
                  </label>
                </div>
              </aside>

              {/* Special Offers List */}
              <div className="lg:col-span-9">
                <div className="flex justify-end items-center mb-4">
                  <button
                    className="text-blue-700 font-bold px-3 sm:px-4 py-2 rounded-md hover:text-blue-800 text-sm sm:text-base"
                    onClick={() => {
                      navigate(Paths.specialOffers);
                    }}
                  >
                    + Create a special offer
                  </button>
                </div>

                {specialOffer.offer?.length === 0 ? (
                  <div className="w-full sm:w-72 flex items-center flex-col justify-center text-center">
                    <p className="text-sm sm:text-md">
                      Sell more tickets with special offers. Give Customers
                      discounted prices for a limited time. They're quick and
                      easy to set up.
                    </p>
                    <div></div>

                    <button
                      onClick={() => navigate(Paths.specialOffers)}
                      className="p-3 bg-blue-600 text-white text-sm sm:text-md my-5"
                    >
                      Create special offer
                    </button>
                  </div>
                ) : (
                  <div>
                    <div className="space-y-4">
                      {currentItems?.map((offer: any) => (
                        <div
                          key={offer.id}
                          className="bg-white p-3 sm:p-4 rounded-md shadow-md flex flex-col sm:flex-row sm:items-center justify-between gap-4"
                        >
                          <div className="flex-1">
                            <h3 className="text-base sm:text-lg font-semibold">
                              {offer.name}
                            </h3>
                            <p className="text-sm sm:text-md text-gray-600">
                              {offer.description}
                            </p>
                            <p className="text-sm sm:text-md text-gray-900 my-2">
                              Special offer period:{" "}
                              <span>
                                {moment(offer.startDate).format("MMM D, YYYY")}
                              </span>{" "}
                              until{" "}
                              <span>
                                {moment(offer.endDate).format("MMM D, YYYY")}
                              </span>
                            </p>

                            <p className="text-sm sm:text-md text-gray-900 my-2">
                              Number of spots: {offer.spots}
                            </p>
                            <p className="text-sm sm:text-md text-gray-900">
                              Number of spots sold: {offer.spotAmount}
                            </p>
                          </div>
                          <div className="flex items-center space-x-2 sm:space-x-4">
                            <span className="bg-gray-200 px-2 sm:px-3 py-1 rounded-md text-sm sm:text-md">
                              {offer.amount}%
                            </span>
                            <span
                              className={`px-2 sm:px-3 py-1 rounded-md text-sm sm:text-md capitalize ${
                                offer.status === "active"
                                  ? "bg-green-100 text-green-800"
                                  : "bg-yellow-100 text-yellow-800"
                              }`}
                            >
                              {offer.status}
                            </span>
                            <div className="relative">
                              <button
                                className="text-gray-800 hover:text-gray-700 text-xl sm:text-2xl"
                                onClick={() => handleDropdownToggle(offer._id)}
                              >
                                &#x22EE;
                              </button>
                              {activeDropdown === offer._id && (
                                <div className="absolute bottom-10 -right-3.5 bg-white rounded shadow-lg mt-2 w-40 z-20">
                                  <button
                                    className="block w-full text-left px-4 py-2 hover:bg-gray-200"
                                    onClick={() => handleViewOnline(offer._id)}
                                  >
                                    {/* <span className='flex items-center'>
                                      <svg
                                        className='mr-2'
                                        xmlns='http://www.w3.org/2000/svg'
                                        viewBox='0 0 24 24'
                                        width='16'
                                        height='16'
                                        fill='currentColor'
                                      >
                                        <path d='M12 3C7 3 2.73 6.11 1 12c1.73 5.89 6 9 11 9s9.27-3.11 11-9c-1.73-5.89-6-9-11-9Zm0 15a6 6 0 1 1 6-6 6 6 0 0 1-6 6Z' />
                                      </svg>
                                      See this offer online
                                    </span> */}
                                  </button>
                                  <button
                                    className="block w-full text-left px-4 py-2 hover:bg-gray-200"
                                    onClick={() => handleEdit(offer._id)}
                                  >
                                    <span className="flex items-center">
                                      <svg
                                        className="mr-2"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                      >
                                        <path d="M13.5 3.5l-9 9L2 14l1.5-2.5 9-9L13.5 3.5ZM5 13l6 6H9v-4H5v-2ZM17 0l2.5 2.5L16 6l-2.5-2.5L17 0ZM6.5 10.5l7-7L15 5l-7 7L6.5 10.5ZM19.5 2l1 1L18 5.5 17 4.5 19.5 2ZM18 7l3.5-3.5 1 1L19 8l-1-1ZM14 4l3 3-2 2-3-3 2-2Z" />
                                      </svg>
                                      Make changes
                                    </span>
                                  </button>
                                  <button
                                    className="block w-full text-left px-4 py-2 hover:bg-gray-200"
                                    onClick={() =>
                                      handlePause(offer._id, offer.status)
                                    }
                                  >
                                    <span className="flex items-center">
                                      <svg
                                        className="mr-2"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                      >
                                        <path d="M6 2h3v20H6V2Zm9 0h3v20h-3V2Z" />
                                      </svg>
                                      {offer.status === "active"
                                        ? "Pause this offer"
                                        : "Activate this offer"}
                                    </span>
                                  </button>
                                  <button
                                    className="block w-full text-left px-4 py-2 hover:bg-gray-200 text-red-600"
                                    onClick={() =>
                                      handleDeleteRequest(offer._id)
                                    }
                                  >
                                    <span className="flex items-center">
                                      <svg
                                        className="mr-2"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                      >
                                        <path d="M3 6h18v16H3V6Zm5 2v10h2V8H8Zm6 0v10h2V8h-2ZM10 0h4v2h6v2H0V2h6V0h4Z" />
                                      </svg>
                                      Delete
                                    </span>
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="flex flex-col sm:flex-row justify-between items-center mt-6 gap-4">
                      <div className="flex items-center space-x-2">
                        <label className="text-sm">Per page</label>
                        <select
                          className="border-gray-300 rounded-md p-2 text-sm"
                          value={itemsPerPage}
                          onChange={handleItemsPerPageChange}
                        >
                          <option value={15}>15</option>
                          <option value={50}>50</option>
                        </select>
                      </div>
                      <div className="flex items-center space-x-2 sm:space-x-4">
                        <button
                          className={`text-gray-500 hover:text-gray-700 text-sm ${
                            currentPage === 1
                              ? "opacity-50 cursor-not-allowed"
                              : ""
                          }`}
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          &laquo; Previous
                        </button>
                        <span className="text-gray-700 text-sm">
                          Page {currentPage} of {totalPages}
                        </span>
                        <button
                          className={`text-gray-500 hover:text-gray-700 text-sm ${
                            currentPage === totalPages
                              ? "opacity-50 cursor-not-allowed"
                              : ""
                          }`}
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          Next &raquo;
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-20">
          <div className="bg-white p-6 rounded-md shadow-lg max-w-sm w-full">
            <h2 className="text-lg font-semibold mb-4">Confirm Delete</h2>
            <p className="text-gray-700 mb-6">
              Are you sure you want to delete this special offer?
            </p>
            <div className="flex justify-end space-x-4">
              <button
                className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400"
                onClick={cancelDelete}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                onClick={confirmDelete}
              >
                {loading ? "Deleting..." : "Yes, Delete"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageSpecialOffersPage;
